<!-- my-account.component.html -->
<div class="account-menu">
  <div class="media profile-media" (click)="toggleMenu()">
    <img class="b-r-10 rounded-circle" src="assets/images/User.jpg" alt=""
      style="width: 35px; height: 35px; object-fit: cover;">
    <div class="media-body">
      <p class="mb-0 font-roboto">{{ displayRole }}</p>
    </div>
    <i class="fa caret" [ngClass]="isOpen ? 'fa-angle-up' : 'fa-angle-down'"></i>
  </div>

  <div class="account-panel" *ngIf="isOpen">
    <button type="button" class="account-item" (click)="goToProfile()">
      <i class="fa fa-user-o"></i>
      <span>Profile</span>
    </button>
    <button type="button" class="account-item logout" (click)="logoutUser()">
      <i class="fa fa-sign-out"></i>
      <span>Log out</span>
    </button>
  </div>
</div>
